module.exports = __webpack_public_path__ + "img/14.56a57042.png";